<template>
  <div class="platinum-banner">
    <img :src="require(`@/assets/images/membership/platinum.svg`)" class="inline-block" />

    <div class="">
      <h2 class="text-lg font-bold">You are on a Platinum membership plan</h2>

      <p class="mt-2 text-sm">If you need any assistance please contact your account manager.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetPlatinumPlanBanner'
}
</script>

<style lang="scss" scoped>
.platinum-banner {
  display: flex;
  max-width: 782px;
  width: 100%;
  padding: 16px;
  border: 1px solid rgba(154, 153, 152, 0.2);
  background: linear-gradient(268.14deg, rgba(154, 153, 152, 0.4) 0%, rgba(154, 153, 152, 0.1) 99.57%);

  img {
    height: 40px;
    margin-top: 5px;
    margin-right: 16px;
  }

  p {
    color: #4B5563;
  }
}
</style>

